// @ts-nocheck
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../../../services/socket.io/socket.io.config";
import {
  JOIN_NEW_CHAT,
  NEW_CHAT_MESSAGE,
  ON_TRIGGER_NOTE_NOTIFICATION
} from "./constants";
import { emitSocketEvent } from "../../../services/apiService";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import { ON_NEW_NOTE_ONE_ON_ONE_CHAT } from "../../../store/constants/noteoneononemessaging";
import { NEW_TRIGGER_NOTE_NOTIFICATION } from "../../../store/constants/notifications";
import { markNotesAsReadActions } from "../../../store/actions/noteOneOnOneMessagingActions";
import { ADD_NEW_NOTE_CHAT_ROOM } from "../../../store/constants/eventRequestDetails";

const useNoteOneOnOneMessagingEvents = ({ roomIds, eventInfo }) => {
  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  const { chatRoomMessages } = useSelector(
    (store) => store.noteOneOnOneMessaging
  );

  const noteOneOnOneMessaging = useSelector(
    (store) => store["noteOneOnOneMessaging"]
  );

  const joinNoteChatRoomsHandler = async ({ token }) => {
    try {
      const response = await emitSocketEvent({
        event: JOIN_NEW_CHAT,
        payload: {
          roomIds,
          eventId: eventInfo?._id,
          token: auth?.userToken
        }
      });

      ///write create note api

      if (response?.status === "failure") {
        console.error(
          "joinNoteChatRoomsHandler: Failed to join chat rooms",
          response
        );
        // dispatch({
        //   type: ALERT_DIALOG,
        //   payload: {
        //       open: true,
        //       title: "Error!",
        //       message: "Some error occured in connecting to the server. Please reload the browser!"
        //   }
        // })
      }

      if (Boolean(roomIds?.[0] === "") && Boolean(eventInfo?._id)) {
        dispatch({
          type: ADD_NEW_NOTE_CHAT_ROOM,
          payload: {
            newChatRoom: {
              ...response?.data,
              chatId: response?.data?._id
            }
          }
        });

        // dispatch({
        //   type: CLEAR_NOTE_CHAT_ROOM_MESSAGES,
        // })
      }
    } catch (error) {
      console.error("[JOIN_CHAT_EXCEPTION]:", error);
      // socket.emit(JOIN_CHAT, {
      //   roomIds: chatRoomIds,
      //   token: auth?.userToken
      // }, (response) => {
      //   console.log(response, "JOIN_CHAT")
      //   if (response?.status === "failure") {
      //     dispatch({
      //       type: ALERT_DIALOG,
      //       payload: {
      //         open: true,
      //         title: "Error!",
      //         message: "Some error occured in connecting to the server. Please reload the browser!"
      //       }
      //     })
      //   }
      // });
    }
  };
  const onNewMessageHandler = async (response) => {
    try {
      const sentMessage = response?.data;

      dispatch({
        type: ON_NEW_NOTE_ONE_ON_ONE_CHAT,
        payload: {
          roomId: sentMessage.roomId,
          message: sentMessage
        }
      });
    } catch (error) {
      console.error("onNewMessageHandler:", error);
    }
  };
  const onTriggerNoteNotificationHandler = async (response) => {
    try {
      const updatedChatMetaData = response?.find(
        (currentItem) => currentItem?.userId === auth?.userId
      );
      dispatch({
        type: NEW_TRIGGER_NOTE_NOTIFICATION,
        payload: {
          updatedChatMetaData
        }
      });
    } catch (error) {
      console.error("onTriggerNoteNotificationHandler:", error);
    }
  };
  React.useEffect(() => {
    socket.on(NEW_CHAT_MESSAGE, onNewMessageHandler);
    socket.on(ON_TRIGGER_NOTE_NOTIFICATION, onTriggerNoteNotificationHandler);
    return () => {
      socket.off(NEW_CHAT_MESSAGE, onNewMessageHandler);
      socket.off(
        ON_TRIGGER_NOTE_NOTIFICATION,
        onTriggerNoteNotificationHandler
      );
    };
  }, []);
  React.useEffect(() => {
    // if ((global && location.pathname === "/event/chat/admin")) {
    //   return;
    if (roomIds?.length > 0) {
      if (roomIds?.[0] || eventInfo?._id) {
        joinNoteChatRoomsHandler({
          roomIds
        });
      }
    }
  }, [roomIds?.[0], eventInfo?._id, auth?.userToken]);

  React.useEffect(() => {
    if (chatRoomMessages?.length > 0) {
      if (!noteOneOnOneMessaging?.isMounted) {
        return;
      }
      dispatch(
        markNotesAsReadActions({
          chatId: chatRoomMessages?.[0]?.chatId
        })
      );
    }
  }, [
    chatRoomMessages?.length,
    noteOneOnOneMessaging?.isMounted,
    auth?.userToken
  ]);
  return {};
};

export default useNoteOneOnOneMessagingEvents;